import React from 'react';

import { DynamicProduct } from '../../../DynamicProduct';
import { availableProductPublicOfferConstant } from '../../../DynamicProduct/components/Product/products/PublicOffer/constants';

export const PublicOfferContent: React.FC = () => (
  <DynamicProduct infoGetter={() => ({})} product={availableProductPublicOfferConstant} />
);
